const CF_DEV_API_URL = 'https://api-dev.hospodska.com/api';

const HOST_API_URL_MAP = {
  'dev.hospodska.com': CF_DEV_API_URL,
  'devsmeny.hospodska.com': CF_DEV_API_URL,
};

/**
 * Resolves the API base URL for the current browser host.
 * Cloudflare parallel-test hosts on hospodska.com map to api-dev.hospodska.com;
 * everything else uses the build-time REACT_APP_API_URL (existing rcbg behaviour).
 */
export const resolveApiUrl = (hostname) => {
  const host =
    hostname ?? (typeof window !== 'undefined' && window.location ? window.location.hostname : '');
  return HOST_API_URL_MAP[host] || process.env.REACT_APP_API_URL;
};

export { CF_DEV_API_URL, HOST_API_URL_MAP };
